import { useTranslations } from 'next-intl';
import { ProfilePicture } from '@dh/components';
import { User } from '@dh/types';
import { BodyMedium, BodySmall, Column, Row } from '@dh/styles';
import { useTheme } from '@dh/hooks';

import { ContactCardBodyMedium, ContactCardItemContainer } from './styles';

type Props = { user: Partial<User> };

export const ContactCardNameItem = ({ user }: Props) => {
    const { profilePicture, title, pronouns, firstname, lastname, institution, jobTitle } = user;
    const t = useTranslations('user');
    const { colors } = useTheme();

    return (
        <ContactCardItemContainer>
            <ProfilePicture
                imageUrl={profilePicture?.url}
                altText={`${firstname} ${lastname} Profile Picture`}
                size={40}
            />
            <Column flex={1}>
                <Row gap={1} alignItems={'end'}>
                    <ContactCardBodyMedium>{`${title ? t(title) + ' ' : ''}${firstname} ${lastname}`}</ContactCardBodyMedium>
                    {pronouns && (
                        <BodyMedium
                            color={colors.disabledText}
                        >{`(${t(pronouns).toLocaleLowerCase()})`}</BodyMedium>
                    )}
                </Row>
                {jobTitle && institution && (
                    <Row>
                        <BodySmall>
                            {jobTitle + ' bei '}
                            {institution.name}
                        </BodySmall>
                    </Row>
                )}
            </Column>
        </ContactCardItemContainer>
    );
};
